var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.0696954,0 C69.9610008,-4.57245863e-15 90.1393907,20.1783899 90.1393907,45.0696954 C90.1393907,69.9610008 69.9610008,90.1393907 45.0696954,90.1393907 C20.1783899,90.1393907 1.72591605e-14,69.9610008 0,45.0696954 C-3.04830575e-15,20.1783899 20.1783899,4.57245863e-15 45.0696954,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supervisor-desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.322628997
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fillOpacity: 0.435724432,
    fill: "#E7304B",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.092706, 9.936000)",
    stroke: "#FFFFFF",
    strokeWidth: 3.42079008
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5872182,22.9012092 L19.4636506,22.9012092 C29.5396516,22.9012092 37.7078643,31.069422 37.7078643,41.145423 L37.7078643,55.9520781 C37.7078643,66.0280791 29.5396516,74.1962918 19.4636506,74.1962918 L13.7623338,74.1962918 L13.7623338,74.1962918",
    id: "Rectangle",
    transform: "translate(25.647541, 48.548751) rotate(-90.000000) translate(-25.647541, -48.548751) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.6475413,
    cy: 14.8234237,
    rx: 12.7860413,
    ry: 13.1130286
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cab7ada866685b8276cb1cd4e3d57c2d.svg";
export { ForwardRef as ReactComponent };